import React, { useRef } from 'react';
import {
  DateField,
  ListBase,
  ListToolbar,
  Pagination,
  Datagrid,
  useRefresh,
  Title,
} from 'react-admin';

import { Divider, Card, makeStyles } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DetailsIcon from '@material-ui/icons/Details';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import MinimizeIcon from '@material-ui/icons/Minimize';
import PrintIcon from '@material-ui/icons/Print';
import { useSnackbar } from 'notistack';

import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { imprimirPacoteMalote } from '../../services/impressora';
import { stylesMalote } from '../../utils';
import { PERMISSAO_TELA_SUBMALOTES_LISTAR } from '../../utils/dadosTelas';
import DialogoLixeira from '../MaloteSangrias/DialogoLixeira';
import ValorTransferenciaField from '../Transacoes/Fields/ValorTransferenciaField';
import Actions from './ActionsList';
import DialogoCriarSubmalote from './DialogoCreate';
import DialogoCriarTroco from './DialogoCriarTroco';
import DialogoEditarSubmalote from './DialogoEditarSubmalote';
import DialogoShowSubmalote from './DialogoShowSubmalote';
//import ActionsField from './Fields/ActionsField';
import CodigoField from './Fields/CodigoField';
import IsCriadoManualmenteField from './Fields/IsCriadoManualmenteField';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => stylesMalote);
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const classes = useStylesDatagrid();
  const refDialogoShowSubmalote = useRef(null);
  const refDialogoCriarTroco = useRef(null);
  const refDialogoEditarSubmalote = useRef(null);
  const refDialogoCriarSubmaloteCompatibilidade = useRef(null);
  const refDialogoLixeira = useRef(null);

  const edit = (data) => {
    if (refDialogoEditarSubmalote.current) {
      refDialogoEditarSubmalote.current.handleOpen(data.id);
    }
  };

  const criarTroco = (data) => {
    if (refDialogoCriarTroco.current) {
      refDialogoCriarTroco.current.handleOpen(data.id);
    }
  };

  const show = (data) => {
    if (refDialogoShowSubmalote.current) {
      refDialogoShowSubmalote.current.handleOpen(data.id);
    }
  };

  const criarSubmaloteCompatibilidade = (data) => {
    if (refDialogoCriarSubmaloteCompatibilidade.current) {
      refDialogoCriarSubmaloteCompatibilidade.current.handleOpen();
    }
  };

  function handleClose() {
    refresh();
  }

  function handleLixeira(data) {
    if (refDialogoLixeira.current) {
      refDialogoLixeira.current.handleOpen(data.id);
    }
  }

  const { enqueueSnackbar } = useSnackbar();

  async function imprimir(id) {
    if (id > 0) {
      const codigo = await imprimirPacoteMalote(id);
      if (codigo < 0) {
        enqueueSnackbar('Erro ao imprimir a nota!', {
          variant: 'error',
        });
      }
    }
  }

  return (
    <>
      <Title title="Submalotes" />
      <ListToolbar
        filters={props.filters}
        actions={
          <Actions
            {...props}
            handleCriarCompatibilizacao={criarSubmaloteCompatibilidade}
          />
        }
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Divider />
        <div>
          <Datagrid>
            <IsCriadoManualmenteField
              source="is_artificial"
              label="Criado Manualmente"
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
              sortable={false}
            />
            <CodigoField
              source="codigo"
              label="Código"
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
              sortable={false}
            />
            <DateField
              source="data_pagamento"
              label="Criação"
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
              options={{ hour: 'numeric', minute: 'numeric' }}
              sortable={false}
            />
            <Textofield
              label="Criador"
              source="criador.username"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.categoriaCell}
            />
            <Textofield
              label="Quem Atualizou"
              source="atualizador.username"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.categoriaCell}
            />
            <ValorTransferenciaField
              source="valor"
              textAlign="right"
              label="Valor"
              headerClassName={classes.dataHeader}
              cellClassName={classes.valorCell}
              sortable={false}
            />
            <ActionsField
              source="lalala"
              /* handleEdit={edit}
              handleShow={show}
              handleDesmembrar={criarTroco} */
              textAlign="right"
              label="Ações"
              headerClassName={classes.dataHeader}
              cellClassName={classes.actionsCell}
              sortable={false}
              //handleLixeira={handleLixeira}
              actions={[
                {
                  title: 'Criar Retirada 100',
                  icon: <MinimizeIcon />,
                  show: () => true,
                  disabled: () => false,
                  onClick: (record) => criarTroco(record),
                },
                {
                  title: 'Detalhes',
                  icon: <DetailsIcon />,
                  show: () => true,
                  disabled: () => false,
                  onClick: (record) => show(record),
                },
                {
                  title: 'Editar',
                  icon: <EditOutlinedIcon />,
                  show: () => true,
                  disabled: () => false,
                  onClick: (record) => edit(record),
                },
                {
                  title: 'Imprimir',
                  icon: <PrintIcon />,
                  show: () => true,
                  disabled: () => false,
                  onClick: (record) => imprimir(record?.id || -1),
                },
                {
                  title: 'Mandar para a lixeira',
                  icon: <DeleteForeverIcon />,
                  show: () => true,
                  disabled: () => false,
                  onClick: (record) => handleLixeira(record),
                },
              ]}
            />
          </Datagrid>
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoShowSubmalote ref={refDialogoShowSubmalote} />
      <DialogoCriarTroco ref={refDialogoCriarTroco} handleClose={handleClose} />
      <DialogoEditarSubmalote
        ref={refDialogoEditarSubmalote}
        handleClose={handleClose}
      />
      <DialogoCriarSubmalote
        ref={refDialogoCriarSubmaloteCompatibilidade}
        handleClose={handleClose}
      />
      <DialogoLixeira ref={refDialogoLixeira} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_SUBMALOTES_LISTAR}>
    <ContainerMyList
      {...props}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Submalotes"
    />
  </ProtegerPagina>
);

export default List2;
